import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function SubLedgerGroupMaster(props) {
  const [subLedgerGroups, setSubLedgerGroups] = useState([]);
  const [subLedgerGroupCode, setSubLedgerGroupCode] = useState('');
  const [subLedgerGroupName, setSubLedgerGroupName] = useState('');
  const [subLedgerGroupNameEng, setSubLedgerGroupNameEng] = useState('');
  const [shortKey, setShortKey] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editSubLedgerGroupId, setEditSubLedgerGroupId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [subLedgerGroupMasterEntries, setSubLedgerGroupMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    fetchSubLedgerGroupMaster();
  }, []);

  const fetchSubLedgerGroupMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgergroups');
      setSubLedgerGroupMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setSubLedgerGroupCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.SubLedgerGroupCode > maxEntryNo) {
        maxEntryNo = entry.SubLedgerGroupCode;
      }
    }
    return maxEntryNo;
  };

  const addSubLedgerGroup = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/subledgergroups', {
        SubLedgerGroupCode: subLedgerGroupCode,
        SubLedgerGroupName: subLedgerGroupName,
        SubLedgerGroupNameEng: subLedgerGroupNameEng,
        ShortKey: shortKey,
        USERID: props.name
      });
      fetchSubLedgerGroupMaster();
      setSubLedgerGroupCode('');
      setSubLedgerGroupName('');
      setSubLedgerGroupNameEng('');
      setShortKey('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateSubLedgerGroup = async (SubLedgerGroupCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/subledgergroups/${SubLedgerGroupCode}`, {
        SubLedgerGroupCode: subLedgerGroupCode,
        SubLedgerGroupName: subLedgerGroupName,
        SubLedgerGroupNameEng: subLedgerGroupNameEng,
        ShortKey: shortKey,
        USERID: props.name
      });
      fetchSubLedgerGroupMaster();
      setSubLedgerGroupCode('');
      setSubLedgerGroupName('');
      setSubLedgerGroupNameEng('');
      setShortKey('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteSubLedgerGroup(deleteEntryNo.SubLedgerGroupCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteSubLedgerGroup = async (SubLedgerGroupCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/subledgergroups/${SubLedgerGroupCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchSubLedgerGroupMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (subLedgerGroup) => {
    setFormMode('edit');
    setSubLedgerGroupCode(subLedgerGroup.SubLedgerGroupCode);
    setSubLedgerGroupName(subLedgerGroup.SubLedgerGroupName);
    setSubLedgerGroupNameEng(subLedgerGroup.SubLedgerGroupNameEng);
    setShortKey(subLedgerGroup.ShortKey);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = subLedgerGroups.filter((subLedgerGroup) => {
      const SubLedgerGroupCode = subLedgerGroup.SubLedgerGroupCode.toString().toLowerCase();
      const SubLedgerGroupName = subLedgerGroup.SubLedgerGroupName.toString().toLowerCase();
      const SubLedgerGroupNameEng = subLedgerGroup.SubLedgerGroupNameEng.toString().toLowerCase();
      const ShortKey = subLedgerGroup.ShortKey.toString().toLowerCase();

      return (
        SubLedgerGroupCode.includes(searchQuery.toLowerCase()) ||
        SubLedgerGroupName.includes(searchQuery.toLowerCase()) ||
        SubLedgerGroupNameEng.includes(searchQuery.toLowerCase()) ||
        ShortKey.includes(searchQuery.toLowerCase())
      );
    });

    setSubLedgerGroupMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, subLedgerGroups]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setSubLedgerGroups(subLedgerGroups);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditSubLedgerGroupId('');
    setSubLedgerGroupCode('');
    setSubLedgerGroupName('');
    setSubLedgerGroupNameEng('');
    setShortKey('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "SubLedgerGroupData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>SubLedgerGroupMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="subLedgerGroupCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SubLedgerGroupCode</label>
              <input
                type="text"
                id="subLedgerGroupCode"
                value={subLedgerGroupCode}
                readOnly
                placeholder="SubLedgerGroupCode"
                style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="subLedgerGroupName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SubLedgerGroupName</label>
              <input
                type="text"
                id="subLedgerGroupName"
                value={subLedgerGroupName}
                onChange={(e) => setSubLedgerGroupName(e.target.value)}
                placeholder="SubLedgerGroupName"
                style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="subLedgerGroupNameEng" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SubLedgerGroupNameEng</label>
              <input
                type="text"
                id="subLedgerGroupNameEng"
                value={subLedgerGroupNameEng}
                onChange={(e) => setSubLedgerGroupNameEng(e.target.value)}
                placeholder="SubLedgerGroupNameEng"
                style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="shortKey" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ShortKey</label>
              <input
                type="text"
                id="shortKey"
                value={shortKey}
                onChange={(e) => setShortKey(e.target.value)}
                placeholder="ShortKey"
                style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
              />
            </div>
          </div>
          <div>
            <button
              className={formMode === 'add' ? 'add-button' : 'update-button'}
              onClick={formMode === 'add' ? addSubLedgerGroup : () => updateSubLedgerGroup(subLedgerGroupCode)}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '10px',
              }}
            >
              {formMode === 'add' ? 'Add' : 'Update'}
            </button>
            <button
              className="view-button"
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '10px',
                marginBottom: '10px',
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SubLedgerGroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SubLedgerGroupName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SubLedgerGroupNameEng
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ShortKey
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {subLedgerGroupMasterEntries.map((subLedgerGroup) => (
                <tr key={subLedgerGroup.SubLedgerGroupCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedgerGroup.SubLedgerGroupCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedgerGroup.SubLedgerGroupName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedgerGroup.SubLedgerGroupNameEng}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{subLedgerGroup.ShortKey}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(subLedgerGroup)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({ SubLedgerGroupCode: subLedgerGroup.SubLedgerGroupCode });
                        setOpenConfirmation(true);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to DELETE ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmation(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SubLedgerGroupMaster;
